module.exports = __webpack_public_path__ + "img/namn-och.ef3527ba.svg";